import { ConstructorType } from '@dooboostore/core';
import { SimNoSuch } from '../throwable/SimNoSuch';
import { getPostConstructs, getSim, Lifecycle, SimConfig, simProcess, sims } from '../decorators/SimDecorator';
import { ObjectUtils } from '@dooboostore/core';
import { SimAtomic } from './SimAtomic';
import { ReflectUtils } from '@dooboostore/core';
import { getInject, isTargetFactory, isTargetNone, isTargetScheme, isTargetSymbol, isTargetType, SaveInjectConfig, SituationTypeContainer, SituationTypeContainers } from '../decorators/inject/Inject';
import { SimOption } from '../SimOption';
import { SimProxyHandler } from '../proxy/SimProxyHandler';
import { ConvertUtils } from '@dooboostore/core';
import { Runnable } from '@dooboostore/core';
import { isOnSimCreate } from '../lifecycle/OnSimCreate';
import { isOnSimCreateProxyCompleted } from '../lifecycle/OnSimCreateCompleted';
import { SimpleApplication } from '../SimpleApplication';
import { isSimNoProxy } from '../decorators/SimNoProxy';
import { RandomUtils } from '@dooboostore/core';
import { ValidUtils } from '@dooboostore/core';

export type FirstCheckMaker = (obj: { target: Object; targetKey?: string | symbol }, token: ConstructorType<any>, idx: number, saveInjectConfig?: SaveInjectConfig) => any | undefined;
export type Carrier = { newInstances: any[]; depth: number };

export class SimstanceManager implements Runnable<void, Map<ConstructorType<any> | Function, any>> {
  private _storage = new Map<ConstructorType<any> | Function, Map<ConstructorType<any> | Function, undefined | any>>();
  private simProxyHandler: SimProxyHandler;
  private name = 'simstanceManager-' + RandomUtils.uuid4();
  // private otherInstanceSim?: Map<ConstructorType<any> | Function, any>;

  constructor(
    public simpleApplication: SimpleApplication,
    private option: SimOption
  ) {
    this.setStoreSet(SimpleApplication, this.simpleApplication);
    this.setStoreSet(SimstanceManager, this);
    this.setStoreSet((option as any).constructor, option);
    this.setStoreSet(SimOption, option);
    this.simProxyHandler = new SimProxyHandler(this.simpleApplication, this, option);
  }

  get storage() {
    return this._storage;
  }

  getSimAtomics(): SimAtomic[] {
    const r: SimAtomic[] = [];
    Array.from(this.storage.entries()).forEach(([targetKeyType, targetMap]) => {
      // Array.from(targetMap).forEach(it => {
      r.push(
        ...Array.from(Array.from(targetMap.keys())).map(
          sit =>
            new SimAtomic(
              {
                targetKeyType,
                originalType: sit
              },
              this
            )
        )
      );
      // });
    });
    return r;
  }

  getSimConfig(schemeOrSymbol: string | symbol | undefined): SimAtomic<any>[] {
    const newVar =
      this.getSimAtomics().filter(it => {
        const config = it?.getConfig();
        const symbols = ConvertUtils.flatArray(config?.symbol);
        const schemes = ConvertUtils.flatArray(config?.scheme);
        if (typeof schemeOrSymbol === 'symbol') {
          return schemeOrSymbol && it && symbols.includes(schemeOrSymbol);
        } else if (typeof schemeOrSymbol === 'string') {
          return schemeOrSymbol && it && schemes.includes(schemeOrSymbol);
        } else {
          return false;
        }
      }) || [];
    return newVar;
  }

  findSims<T = any>(symbol: symbol): SimAtomic<T>[];
  findSims<T = any>(data: { scheme?: string; type?: ConstructorType<any> | Function }): SimAtomic<T>[];
  findSims<T = any>(
    data:
      | {
          scheme?: string;
          type?: ConstructorType<any> | Function;
        }
      | symbol
  ): SimAtomic<T>[] {
    let r: SimAtomic<T>[] = [];
    if (data) {
      const simAtomics = this.getSimAtomics();
      r = simAtomics.filter(it => {
        let b = false;
        const config = it.getConfig();
        // console.log('-=--', config)
        const symbols = ConvertUtils.flatArray(config?.symbol).filter(ValidUtils.isDefined);
        const schemes = ConvertUtils.flatArray(config?.scheme).filter(ValidUtils.isDefined);
        if (typeof data === 'symbol') {
          b = symbols.includes(data);
        } else {
          const { scheme, type } = data as { scheme?: string; type?: ConstructorType<any> | Function };
          b = (scheme ? schemes.includes(scheme) : true) && (type ? it.type.targetKeyType === type : true);
          // if (type) {
          //   const configTypes = ConvertUtils.flatArray(config?.type).filter(isDefined);
          //   const match = configTypes.includes(type)
          //   if (match) {
          //     b = true;
          //   }
          // }
        }
        return b;
      }) as unknown as SimAtomic<T>[];
    }
    return r;
  }

  findFirstSim<T = any>(symbol: symbol): SimAtomic<T> | undefined;
  findFirstSim<T = any>(data: { scheme?: string; type?: ConstructorType<any> | Function }): SimAtomic<T> | undefined;
  findFirstSim<T = any>(data: { scheme?: string; type?: ConstructorType<any> | Function } | symbol): SimAtomic<T> | undefined {
    if (typeof data === 'symbol') {
      return this.findSims(data)[0];
    } else {
      return this.findSims(data as { scheme?: string; type?: ConstructorType<any> | Function })[0];
    }
  }

  findLastSim<T = any>(symbol: symbol): SimAtomic<T> | undefined;
  findLastSim<T = any>(data: { scheme?: string; type?: ConstructorType<any> | Function }): SimAtomic<T> | undefined;
  findLastSim<T = any>(
    data:
      | {
          scheme?: string;
          type?: ConstructorType<any> | Function;
        }
      | symbol
  ): SimAtomic<T> | undefined {
    if (typeof data === 'symbol') {
      return this.findSims(data).reverse()[0];
    } else {
      return this.findSims(data as { scheme?: string; type?: ConstructorType<any> | Function }).reverse()[0];
    }
  }

  flatStoreSets() {
    return new Map(
      Array.from(this.storage.values())
        .map(it => Array.from(it.entries()))
        .flat()
    );
  }

  getStoreSets<T>(targetKey: ConstructorType<T> | Function): { type: ConstructorType<T> | Function; instance?: T }[] {
    const map = this.storage.get(targetKey);
    const datas = (Array.from(map?.entries?.() ?? []) ?? []).reverse();
    return datas.map(it => ({ type: it[0], instance: it[1] }));
  }

  getStoreSet<T>(targetKey: ConstructorType<T> | Function, target?: ConstructorType<any> | Function): { type: ConstructorType<T> | Function; instance?: T } | undefined {
    const sets = this.getStoreSets(targetKey);
    let find = sets.find(it => it.type === target);
    if (!find && (!target || target === targetKey)) {
      find = sets.find(it => it.instance);
    }
    // console.log('getStoreSet', targetKey, target, find)
    if (!find?.instance) {
      const type = target ?? targetKey;

      // 외부에서 넣어준 인스턴스트일때에는 키값이 그 instance이다.
      if (typeof type === 'object') {
        const find = this.storage.get(type);
        if (find) {
          return { type: type as ConstructorType<T> | Function, instance: type as T };
        }
      }

      const flatStoreSets = this.flatStoreSets();
      const data = flatStoreSets.get(type);
      // console.log('--->target?', target, targetKey, type, data);
      if (data) {
        this.setStoreSet(targetKey, data, type);
      }
      return { type: type, instance: data };
    } else {
      return find;
    }
    // return find ?? this.getStoreSets(targetKey)[0];
  }

  getStoreInstance<T>(targetKey: ConstructorType<T>, target?: ConstructorType<any>) {
    return this.getStoreSet(targetKey, target)?.instance;
  }

  getOrNewSim<T>({ target, originTypeTarget = target, newInstanceCarrier }: { target?: ConstructorType<T> | Function; newInstanceCarrier?: Carrier; originTypeTarget?: ConstructorType<T> | Function }): T | undefined {
    if (target) {
      const registed = this.getStoreSet(target, originTypeTarget);
      if (registed?.type && !registed?.instance) {
        return this.resolve({
          targetKey: target,
          target: originTypeTarget,
          newInstanceCarrier: newInstanceCarrier
        });
      }
      return registed?.instance;
    }
  }

  setStoreSet(targetKey: ConstructorType<any> | Function, obj: any, target: ConstructorType<any> | Function = targetKey): void {
    const itemMap = this.storage.get(targetKey) ?? new Map<ConstructorType<any> | Function, any>();
    itemMap.set(target, obj);
    this.storage.set(targetKey, itemMap);
  }

  registerStore(targetKey: ConstructorType<any> | Function, regTyps: Set<ConstructorType<any> | Function | any>): void {
    const itemMap = this.storage.get(targetKey) ?? new Map<ConstructorType<any> | Function, any>();
    regTyps.forEach(it => {
      const { type, value } = (typeof it === 'object' ? { type: it.constructor, value: it } : { type: it, value: undefined }) as { type: ConstructorType<any> | Function; value: any };
      if (!itemMap.has(type) || (value !== undefined && itemMap.get(type) === undefined)) {
        itemMap.set(type, value);
      }
    });
    this.storage.set(targetKey, itemMap);
  }

  // 진입점
  resolve<T>({ target, targetKey, newInstanceCarrier = { newInstances: [], depth: 0 } }: { targetKey: ConstructorType<any> | Function; target?: ConstructorType<any> | Function; newInstanceCarrier?: Carrier }): T {
    // console.group('resolve')
    const registed = this.getStoreSet(targetKey, target);
    if (registed?.instance) {
      return registed.instance;
    }

    // console.log('resolve--', targetKey, target, registed?.instance);
    if (this.storage.has(targetKey) && undefined === registed?.instance) {
      newInstanceCarrier.depth++;
      const newSim = this.newSim({
        target: registed?.type ?? targetKey,
        newInstanceCarrier: newInstanceCarrier,
        simCreateAfter: data => {
          // console.log('resolve--newSim', targetKey, target, data);
          if (getSim(registed?.type ?? target ?? targetKey)?.scope === Lifecycle.Singleton) {
            this.setStoreSet(targetKey, data, target);
            // console.log('-----------set', targetKey, data, target, this.storage.get(targetKey))
          }
        }
      });
      newInstanceCarrier.depth--;
      // 한그룹이 끝났을때
      if (newInstanceCarrier.depth === 0) {
        newInstanceCarrier.newInstances.forEach(it => {
          this.callBindPostConstruct(it);
        });
      }
      // console.log('%c *************************','color: blue', registed?.type ?? targetKey ,newInstanceCarrier, newInstanceCarrier?.newInstances.length)
      // console.dir(newInstanceCarrier, {depth:10});
      // console.table(newInstanceCarrier);
      if (isOnSimCreate(newSim)) {
        newSim.onSimCreate();
      }
      // console.groupEnd();
      return newSim;
    }
    // console.log('simstanceManager', this._storage, this.name);
    const simNoSuch = new SimNoSuch('SimNoSuch: no simple instance(resolve) ' + 'name:' + targetKey?.prototype?.constructor?.name + ',' + targetKey);
    console.error(simNoSuch);
    // console.groupEnd();
    throw simNoSuch;
  }

  public newSim<T = any>({ target, simCreateAfter, otherStorage, newInstanceCarrier }: { target: ConstructorType<T> | Function; simCreateAfter?: (data: T) => void; newInstanceCarrier?: Carrier; otherStorage?: Map<ConstructorType<any>, any> }): T {
    // @ts-ignore TODO: 여기서 생성
    const parameters = this.getParameterSim({
      target: target,
      otherStorage: otherStorage,
      newInstanceCarrier: newInstanceCarrier
    });
    // @ts-ignore
    const r = ValidUtils.isFunctionType(target) && !target.prototype ? (target as Function)(...parameters) : new (target as ConstructorType<any>)(...parameters);
    let p = this.proxy(r);
    const config = getSim(target);
    if (config?.proxy) {
      const proxys = (Array.isArray(config.proxy) ? config.proxy : [config.proxy]).filter(ValidUtils.isDefined);
      proxys.forEach(it => {
        // console.log('proxy-----------------', p)
        if (typeof it === 'object') {
          p = new Proxy(p, it);
        } else {
          const simConfig = getSim(it);
          p = new Proxy(p, simConfig ? this.getOrNewSim({ target: it }) : this.newSim({ target: it }));
        }
        // console.log('proxy-pp----------------', p)
      });
    }
    newInstanceCarrier?.newInstances.push(p);
    // 순환참조 막기위한 콜백 처리
    simCreateAfter?.(p);
    if (isOnSimCreateProxyCompleted(p)) {
      p.onSimCreateProxyCompleted(p);
    }
    // this.callBindPostConstruct(p);
    return p;
  }

  public callBindPostConstruct(obj: any) {
    // const set = new Set(ObjectUtils.getAllProtoTypeName(obj));
    // console.log('callBindPostConstruct', obj, set, ObjectUtils.getAllProtoTypeName(obj));
    // set.forEach(it => {
    //   const postConstruct = getPostConstruct(obj, it);
    //   if (postConstruct) {
    //     (obj as any)[it](...this.getParameterSim({target: obj, targetKey: it}))
    //   }
    // })
    const postConstruct = getPostConstructs(obj);
    postConstruct.forEach(it => {
      (obj as any)[it.property](...this.getParameterSim({ target: obj, targetKey: it.property }));
    });
  }

  public async executeBindParameterSimPromise({ target, targetKey, firstCheckMaker, parameterCount, inputParameters }: { target: Object; targetKey?: string | symbol; firstCheckMaker?: FirstCheckMaker[]; parameterCount?: number; inputParameters?: any[] }, otherStorage?: Map<ConstructorType<any>, any>) {
    const binds = this.getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, parameterCount, inputParameters });

    // 비동기 팩토리(Promise)가 생성한 파라미터들이 모두 완료될 때까지 대기
    const resolvedBinds = await Promise.all(binds);

    if (typeof target === 'object' && targetKey) {
      const targetMethod = (target as any)[targetKey];
      return targetMethod?.bind(target)?.(...resolvedBinds);
    } else if (typeof target === 'function' && !targetKey) {
      return new (target as ConstructorType<any>)(...resolvedBinds);
    }
  }

  public executeBindParameterSim({ target, targetKey, firstCheckMaker, parameterCount, inputParameters }: { target: Object; targetKey?: string | symbol; firstCheckMaker?: FirstCheckMaker[]; parameterCount?: number; inputParameters?: any[] }, otherStorage?: Map<ConstructorType<any>, any>) {
    const binds = this.getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, parameterCount, inputParameters });
    if (typeof target === 'object' && targetKey) {
      const targetMethod = (target as any)[targetKey];
      return targetMethod?.bind(target)?.(...binds);
    } else if (typeof target === 'function' && !targetKey) {
      return new (target as ConstructorType<any>)(...binds);
    }
  }

  public getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, newInstanceCarrier, parameterCount, inputParameters = [] }: { target: Object; targetKey?: string | symbol; firstCheckMaker?: FirstCheckMaker[]; newInstanceCarrier?: Carrier; otherStorage?: Map<ConstructorType<any>, any>; parameterCount?: number; inputParameters?: any[] }): any[] {
    const paramTypes = (ReflectUtils.getParameterTypes(target, targetKey) || []) as ConstructorType<any>[];
    // const paramNames = FunctionUtils.getParameterNames(target, targetKey);
    // const a = ReflectUtils.getType(target, 'user');
    let injections: any[] = [];
    const injects = getInject(target, targetKey);
    // const da = JSON.stringify(this.storage);
    // this.storage map to json String

    const loopCount = Math.max(paramTypes.length, parameterCount ?? 0);

    injections = [];
    for (let idx = 0; idx < loopCount; idx++) {
      const token = paramTypes[idx];
      const saveInject = injects?.find(it => it.index === idx);

      // firstCheckMaker should have the highest priority
      let isFirstChecked = false;
      for (const f of firstCheckMaker ?? []) {
        const firstCheckObj = f({ target, targetKey }, token, idx, saveInject);
        if (undefined !== firstCheckObj) {
          injections.push(firstCheckObj);
          isFirstChecked = true;
          break;
        }
      }
      if (isFirstChecked) continue;

      if (saveInject) {
        const inject = saveInject.config;
        let obj = otherStorage?.get(token);

        // console.log('vvvvv----->', obj, token, inject);
        if (token === Array && (isTargetType(inject) || isTargetScheme(inject) || isTargetSymbol(inject))) {
          const p: any[] = [];
          if (isTargetType(inject) && inject.type) {
            p.push(
              ...this.getStoreSets(inject.type)
                .map(it =>
                  this.resolve({
                    targetKey: inject.type!,
                    target: it.type,
                    newInstanceCarrier: newInstanceCarrier
                  })
                )
                .reverse()
            );
          }
          if (isTargetSymbol(inject)) {
            p.push(...this.getSimConfig(inject.symbol).map(it => it.getValue({ newInstanceCarrier: newInstanceCarrier })));
          }
          if (isTargetScheme(inject)) {
            p.push(...this.getSimConfig(inject.scheme).map(it => it.getValue({ newInstanceCarrier: newInstanceCarrier })));
          }
          injections.push(p);
          continue;
        }

        // situational
        if (inject.situationType && otherStorage) {
          // TODO: 왜 other에서 가져오는걸까?
          const situations = otherStorage.get(SituationTypeContainers) as SituationTypeContainers;
          const situation = otherStorage.get(SituationTypeContainer) as SituationTypeContainer;
          if (inject.situationType === situation?.situationType) {
            obj = situation.data;
          } else if (situations && situations.length > 0) {
            const find = situations.find(a => {
              if (a.index !== undefined) {
                return a.situationType === inject.situationType && a.index === idx;
              } else {
                return a.situationType === inject.situationType;
              }
            });
            if (find) {
              obj = find.data;
            }
          }
        }

        if (!obj) {
          // [아키텍트님의 정석] 주입 3대 전략 (Factory / Symbol / Type)
          const currentInstance = typeof target === 'object' ? target : undefined;
          if (isTargetFactory(inject)) {
            // Choice 3: 순수 Factory 전략
            // **핵심 수정 부분**: 이전에 해석된 injections 또는 inputParameters를 모두 결합하여 전달
            const combinedParameters = injections.length > 0 ? injections : inputParameters;
            obj = inject.factory({
              instance: currentInstance,
              methodName: String(targetKey),
              parameter: combinedParameters,
              application: this.simpleApplication
            });
          } else {
            // Choice 1 & 2: Symbol 또는 Type/Scheme 전략
            let findLastSim;
            if (isTargetSymbol(inject)) {
              findLastSim = this.findLastSim(inject.symbol);
            } else if (isTargetType(inject) || isTargetScheme(inject)) {
              findLastSim = this.findLastSim(inject);
            }
            try {
              obj = findLastSim
                ? this.resolve<any>({
                    targetKey: findLastSim?.type.targetKeyType ?? token,
                    newInstanceCarrier: newInstanceCarrier
                  })
                : this.resolve<any>({
                    targetKey: token,
                    newInstanceCarrier: newInstanceCarrier
                  });

              // Augmentation: 찾은 객체를 팩토리를 통해 가공
              if (inject.factory && obj) {
                if (typeof inject.factory === 'function') {
                  const combinedParameters = injections.length > 0 ? injections : inputParameters;
                  obj = inject.factory({
                    instance: currentInstance,
                    methodName: String(targetKey),
                    parameter: combinedParameters,
                    application: this.simpleApplication,
                    injectInstance: obj
                  });
                }
              }
            } catch (e) {
              // Inject optional 처리
              if (inject.optional) {
                injections.push(undefined);
                continue;
              } else {
                throw e;
              }
            }
          }
        }

        if (inject.proxy && obj) {
          // [아키텍트님의 정석] 통합 프록시 전략 (클래스 또는 팩토리 함수)
          if (ValidUtils.isClassType(inject.proxy)) {
            // Choice A: 클래스 프록시
            const handler = getSim(inject.proxy) ? this.getOrNewSim({ target: inject.proxy as ConstructorType<any> }) : new (inject.proxy as any)();
            if (handler) {
              obj = new Proxy(obj, handler);
            }
          } else if (typeof inject.proxy === 'function') {
            // Choice B: 즉석 팩토리 프록시
            const handler = inject.proxy({
              application: this.simpleApplication,
              instance: obj
            });
            if (handler) {
              obj = new Proxy(obj, handler);
            }
          }
        }
        injections.push(obj);
      } else {
        const obj = otherStorage?.get(token) ?? (token ? this.resolve<any>({ targetKey: token, newInstanceCarrier }) : undefined);
        injections.push(obj);
      }
    }
    return injections;
  }

  public proxy<T = any>(target: T): T {
    try {
      const noProxy = isSimNoProxy(target);
      const isExcludeProxy = this.option.excludeProxys?.some(it => target instanceof it);
      if (!noProxy && !isExcludeProxy && target !== null && getSim(target) && typeof target === 'object' && !('_SimpleBoot_isProxy' in target)) {
        for (const key in target) {
          if (!isSimNoProxy(target, key)) {
            (target as any)[key] = this.proxy((target as any)[key]);
          }
        }

        // function apply proxy
        const protoTypeName = ObjectUtils.ownPropertyNames(target);
        protoTypeName
          .filter(it => typeof (target as any)[it] === 'function')
          .filter(it => !isSimNoProxy(target, it))
          .filter(it => !('_SimpleBoot_isProxy' in target[it]))
          .forEach(it => {
            (target as any)[it] = new Proxy((target as any)[it], this.simProxyHandler!);
          });

        if (this.simProxyHandler) {
          target = new Proxy(target, this.simProxyHandler);
        }
      }

      if (this.option.proxy) {
        target = this.option.proxy.onAfterProxy(target);
      }
      return target;
    } catch (e) {
      console.log('sim proxy error');
      throw e;
    }
  }

  run(otherInstanceSim: Map<ConstructorType<any> | Function | SimConfig | symbol, any> = new Map()) {
    // this.otherInstanceSim = new Map();
    for (const [k, v] of Array.from(otherInstanceSim.entries())) {
      const storageKey = typeof k === 'object' && k !== null && 'type' in (k as any) ? (k as any).type : k;
      this.registerStore(storageKey, new Set([v]));

      if (typeof k === 'object' && k !== null && 'symbol' in (k as any) && (k as any).symbol) {
        this.registerStore((k as any).symbol, new Set([v]));
      }
    }
    // this.otherInstanceSim = otherInstanceSim;
    // const types = Array.from(this.otherInstanceSim?.entries()).map(it => ({type: it[0], value: it[1], action: this.setStoreSet.bind(this)}));
    // types.push(...Array.from(sims.entries()).map(it => ({type: it[0], value: it[1], action: this.registerStore.bind(this)})));
    const myContainers: (SimpleApplication | symbol)[] = ConvertUtils.flatArray(this.option.container).filter(ValidUtils.isDefined);
    if (!myContainers.includes(this.simpleApplication)) {
      myContainers.push(this.simpleApplication);
    }
    Array.from(sims.entries()).forEach(([type, implementations]) => {
      const filteredSet = new Set<any>();

      implementations.forEach(impl => {
        const config = getSim(impl);
        const targetContainers = ConvertUtils.flatArray(config?.container).filter(ValidUtils.isDefined);

        let isInclude = false;
        if (targetContainers.length <= 0) {
          // 자기 자신(Global)에 해당되는 애들만 (myContainers 안에 SimpleApplication 본체만 있거나 옵션으로 준 컨테이너가 없을 때)
          // 하지만 기본적으로 myContainers에는 항상 this.simpleApplication이 들어가 있음.
          // 사용자가 option.container에 무언가를 넘겼다면(ex: Symbol('front')),
          // targetContainers가 0개인 놈들은 그 특수 컨테이너(Symbol) 환경에는 끼어들면 안 된다는 요구사항 반영.
          if (myContainers.length === 1 && myContainers[0] === this.simpleApplication) {
            isInclude = true;
          }
        } else {
          isInclude = myContainers.some(it => targetContainers.includes(it as any));
        }

        if (isInclude) {
          filteredSet.add(impl);
        }
      });

      if (filteredSet.size > 0) {
        this.registerStore(type, filteredSet);
      }
    });

    this.callBindPostConstruct(this);

    // auto start run
    this.getSimAtomics().forEach(it => {
      if (it.getConfig()?.autoCreate) {
        // console.log('autoStart---?', it.type);
        it.getValue();
      }
    });
  }
}
